module.exports = __webpack_public_path__ + "static/media/chart1_data.cca71c9e.csv";